import { Component, OnInit } from '@angular/core';
import { BaseInterviewFormFieldComponent, BaseFormFieldServices } from '../base-interview-form-field/base-interview-form-field.component';
import { SharedModule } from '@Shared/shared.module';
import { FieldDetailsComponent } from '@Components/field-details/field-details.component';
import { InterviewProcessingStatusComponent } from '@App/interview/components/interview-processing-status/interview-processing-status.component';

@Component({
    selector: 'action-button',
    templateUrl: './action-button.component.html',
    styleUrls: ['./action-button.component.scss'],
    imports: [SharedModule, FieldDetailsComponent, InterviewProcessingStatusComponent]
})
export class ActionButtonComponent extends BaseInterviewFormFieldComponent implements OnInit {
    constructor(public services: BaseFormFieldServices) {

        super(services);
    }

    ngOnInit() {
        super.initialize({
            inputType: 'actionButton',
            skipValidators: true
        });
    }

    /**
   * Calling post Actions on click of action button
   */
    onClickActionButton() {
        // Eject here if not in live mode - otherwise we need to wrap the onBlur within the action,
        // because that is what ends up doing the real work that we need to track.
        if (!this.isLiveMode()) {
            this.onBlur(true);
            return;
        }

        const caseDetails = this.services.interviewService.getInterviewData().caseDetails;
        const eventProperties = caseDetails
            ? {
                "sectionName": this.services.interviewService.getActiveSection().name,
                "caseNumber": caseDetails.caseNumber,
                "accountCode": this.services.interviewService.account.code,
                "role": this.userRole,
                "sessionId": this.services.signalRService.getSessionId(),
                "questionReference": this.config.questionTitle,
                "caseCreatedDate": caseDetails.creationDate
            }
            : null;

        this.services.monitorService.runAction(`Answered Question`, eventProperties, () => {
            this.group.get(this.config.id).setErrors(null);
            this.config.answerTimeStamp = new Date();
            this.onBlur(true);
        });
    }
}
